export default String.raw`
.news {
    padding: 0 32px;

    &__swiper {
        overflow-x: visible;
    }

    &__arrows {
        visibility: hidden;
    }

    &__slide {
        width: calc(100% / 2.5);
    }
}
`